import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { Box, Button, Card, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Switch, FormControlLabel, FormLabel, Typography, Chip, OutlinedInput, Autocomplete } from "@mui/material";
import { postSaveObjectApi, putUpdateObjectApi } from "api/general";
import { ANNOUNCEMENT } from "app/utils/constants/customConstant";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';
import config from '../../../config';

function AddUpdateAnnouncementCard({ afterUpdateFunc, selectedAnnouncement, onClose, addAfterTable }) {

    const empty_announcementObj = {
        title: '',
        body: '',
        status: 1,
        addedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        updatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        fromAnnouncement: 'Kurum',
        toAnnouncement: config.institutions.map(x => x.inst)
    }
    const [announcementObj, setAnnouncementObj] = useState(empty_announcementObj)
    const { authUser } = useSelector(state => state.auth);

    useEffect(() => {
        if (selectedAnnouncement) {
            const updatedAnnouncement = { ...selectedAnnouncement };

            // toAnnouncement'ı array'e çevir
            if (typeof selectedAnnouncement.toAnnouncement === 'string') {
                if (selectedAnnouncement.toAnnouncement.trim() === '') {
                    updatedAnnouncement.toAnnouncement = config.institutions.map(x => x.inst);
                } else {
                    // Virgül ile ayrılmış string'i array'e çevir
                    updatedAnnouncement.toAnnouncement = selectedAnnouncement.toAnnouncement.split(',').filter(item => item.trim() !== '');
                }
            } else if (!Array.isArray(selectedAnnouncement.toAnnouncement)) {
                updatedAnnouncement.toAnnouncement = config.institutions.map(x => x.inst);
            }

            setAnnouncementObj(updatedAnnouncement);
        } else {
            setAnnouncementObj(empty_announcementObj);
        }
    }, [selectedAnnouncement])

    const handleChange = name => (e) => {
        setAnnouncementObj({
            ...announcementObj,
            [name]: e.target.value
        })
    }

    const handleSwitchChange = (name) => (event) => {
        setAnnouncementObj({
            ...announcementObj,
            [name]: event.target.checked ? 1 : 0
        })
    }

    const handleCKEditorChange = (event, editor) => {
        const data = editor.getData();
        setAnnouncementObj({
            ...announcementObj,
            body: data
        });
    };

    const handleToAnnouncementChange = (event, newValue) => {
        setAnnouncementObj({
            ...announcementObj,
            toAnnouncement: newValue || []
        });
    };

    const handleAddUpdateAnnouncementInfo = () => {
        onClose();

        // toAnnouncement array'ini virgülle ayrılmış string'e çevir (TDK,TTK formatında)
        const toAnnouncementString = Array.isArray(announcementObj.toAnnouncement)
            ? announcementObj.toAnnouncement.join(',')
            : announcementObj.toAnnouncement;

        const announcementData = {
            ...announcementObj,
            toAnnouncement: toAnnouncementString,
            userId: authUser.id,
            updatedDate: moment().format('YYYY-MM-DD HH:mm:ss')
        };

        selectedAnnouncement ?

            Swal.fire({
                title: 'Duyuru Güncelleme İşlemi',
                text: "Güncellemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Güncelle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {

                    const result = await putUpdateObjectApi(ANNOUNCEMENT, announcementData);

                    if (result.status) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Güncelleme başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        afterUpdateFunc && afterUpdateFunc({ ...announcementData })
                    }
                }
            })

            :

            Swal.fire({
                title: 'Duyuru Ekleme İşlemi',
                text: "Eklemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Ekle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {

                    const result = await postSaveObjectApi(ANNOUNCEMENT, announcementData);

                    if (result.status) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Ekleme başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        addAfterTable({ id: result.data.insertId, ...announcementData })
                    }
                }
            })
    };

    return (
        <>
            <JumboCardQuick>
                <Grid container marginY={1} spacing={1} rowSpacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Duyuru Başlığı"
                            fullWidth
                            value={announcementObj['title']}
                            onChange={handleChange("title")}
                            required
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel>Kimden</InputLabel>
                            <Select
                                value={announcementObj['fromAnnouncement']}
                                onChange={handleChange("fromAnnouncement")}
                                label="Kimden"
                            >
                                <MenuItem value="Kurum">Kurum</MenuItem>
                                <MenuItem value="Yazılım">Yazılım</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <Autocomplete
                            multiple
                            size="small"
                            id="to-announcement-autocomplete"
                            options={config.institutions.map(x => x.inst)}
                            value={Array.isArray(announcementObj['toAnnouncement']) ? announcementObj['toAnnouncement'] : []}
                            onChange={handleToAnnouncementChange}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                                <TextField {...params} label="Kime" variant="outlined" size="small" />
                            )}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"tr"}>
                            <FormLabel component="legend">Eklenme Tarihi</FormLabel>
                            <DateTimePicker
                                placeholder="Tarih Seçiniz"
                                value={announcementObj.addedDate}
                                onChange={(newValue) => {
                                    const formattedDate = moment(newValue).format('YYYY-MM-DD HH:mm:ss');
                                    setAnnouncementObj({
                                        ...announcementObj,
                                        addedDate: formattedDate
                                    });
                                }}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                required
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <FormLabel component="legend">Duyuru Durumu</FormLabel>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={announcementObj['status'] === 1}
                                        onChange={handleSwitchChange("status")}
                                        color="primary"
                                    />
                                }
                                label={announcementObj['status'] === 1 ? "Açık" : "Kapalı"}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'medium' }}>
                            Duyuru İçeriği *
                        </Typography>
                        <Box sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            overflow: 'hidden',
                            minHeight: '300px',
                            '& .ck-editor__editable': {
                                minHeight: '250px !important'
                            }
                        }}>
                            <CKEditor
                                editor={ClassicEditor}
                                data={announcementObj['body']}
                                onChange={handleCKEditorChange}
                                config={{
                                    language: 'tr',
                                    toolbar: [
                                        'heading',
                                        '|',
                                        'bold', 'italic', 'link',
                                        '|',
                                        'bulletedList', 'numberedList',
                                        '|',
                                        'blockQuote',
                                        '|',
                                        'undo', 'redo'
                                    ],
                                    placeholder: 'Duyuru içeriğini buraya yazın...'
                                }}
                            />
                        </Box>
                    </Grid>


                </Grid>
            </JumboCardQuick>

            <br />
            <Card>
                <Box sx={{ margin: '8px' }}>
                    <Grid container justifyContent="flex-end" spacing={1}>
                        <Grid item>
                            <Button variant="contained" color="success" onClick={() => handleAddUpdateAnnouncementInfo()}>
                                {selectedAnnouncement ? "Güncelle" : "Kaydet"}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="error" onClick={() => onClose()}>
                                Kapat
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </>
    )
}

export default AddUpdateAnnouncementCard